import React from "react";
import { Link } from "react-router-dom";
import Icon from "./Icon";
import "../styles/ctaBanner.css";

function CtaBanner({
  eyebrow = "Request a demo",
  title = "See MPeoples HRMS on your own attendance data",
  subtitle = "Tell us a little about your organization and we'll walk you through attendance, leave, payroll, and the Admin Dashboard.",
  primaryLabel = "Request a Demo",
  primaryTo = "/contact",
}) {
  return (
    <section className="cta-banner">
      <div className="container cta-banner-inner">
        <div className="cta-banner-copy">
          <span className="eyebrow cta-banner-eyebrow">
            <span className="eyebrow-dot" aria-hidden="true" />
            {eyebrow}
          </span>
          <h2 className="cta-banner-title">{title}</h2>
          <p className="cta-banner-subtitle">{subtitle}</p>
        </div>
        <Link to={primaryTo} className="btn btn-primary cta-banner-btn">
          {primaryLabel}
          <Icon name="arrow" size={16} />
        </Link>
      </div>
    </section>
  );
}

export default CtaBanner;
